import FragmentToolbarNavigation from "./FragmentToolbarNavigation";
import { View,  ViewStyle, TextStyle } from 'react-native';
import {ToolbarProps, Views} from 'react-big-calendar';
import { VacancesType } from "../../../../api/Absence/types";
import FragmentToolbarView from "./FragmentToolbarView";
import React, { useMemo } from "react";
import FragmentToolbarVacances from "./FragmentToolbarVacances";
import { EventType } from "../../../../api/DemandeAbsence/types";
import { ModeCalendrier } from "../../CalendrierUniversel.types";
import { stdCouleurBleu } from "@commonStyle";
import FragmentToolbarDate from "./FragmentToolbarDate";

type Props = {
  mode: ModeCalendrier,
  vacances: VacancesType[],
  buttonSize?: number,
  isFerie: (date: Date) => boolean,
  toggleVacances: (label: string) => void
}

export default function Toolbar(props: ToolbarProps<EventType> & Props) {
  const {mode, label, date, view, buttonSize = 15, isFerie} = props;

  const toolbarStyle = useMemo<ViewStyle>(() => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 10,
    backgroundColor: view === Views.DAY && isFerie(date) ? '#A8FF9E' : stdCouleurBleu,
    borderRadius: 12,
    marginBottom: 10,
    gap: '1%',
  }), [date, isFerie, view])

  const buttonStyle = useMemo<ViewStyle>(() => ({
    borderWidth: 0.2,
    padding: 3,
    borderStyle: 'solid',
    borderColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: buttonSize,
    height: buttonSize * 1.5,
    width: '100%'
  }), [buttonSize])

  const textStyle = useMemo<TextStyle>(() => ({
    color: stdCouleurBleu,
    textAlign: 'center',
    includeFontPadding: false,
    fontWeight: 'bold',
    fontSize: buttonSize,
  }), [buttonSize])

  const titleStyle = useMemo<TextStyle>(() => ({
    color: view === Views.DAY && isFerie(date) ? 'black' : 'white',
    fontWeight: 'bold',
    fontSize: buttonSize,
    flex: 1,
    minWidth: '60%',
    textAlign: 'center',
  }), [buttonSize, date, isFerie, view])

  return (
    <View style={toolbarStyle}>
      <FragmentToolbarNavigation {...props} buttonStyle={buttonStyle} buttonSize={buttonSize} />
      {mode !== 'month' && <FragmentToolbarView {...props} buttonStyle={buttonStyle} buttonSize={buttonSize} />}
      <FragmentToolbarDate {...props} label={label} titleStyle={titleStyle} />
      <FragmentToolbarVacances {...props} buttonStyle={buttonStyle} textStyle={textStyle} />
    </View>
  )
}
